const TicketDetails = ({ticketDetails}) => {
   
    return (
        <div className="mjsdev-dtl-section">
            <div className="mjsdev-dtl-sec-header"><h4>{ticketDetails.subject}</h4></div>
            <div className="mjsdev-dtl-inner-container">
                <div className="mjsdev-dtl-row">
                    <span>Ticket ID</span>
                    <span>#{ticketDetails.ticket_number || ''}</span>
                </div>
                <div className="mjsdev-dtl-row">
                    <span>Customer</span>
                    <span>{ticketDetails.user?.name} ({ticketDetails.user?.email})</span>
                </div>
                <div className="mjsdev-dtl-row">
                    <span>Category</span>
                    <span>{ticketDetails.category}</span>
                </div>
                <div className="mjsdev-dtl-row">
                    <span>Priority</span>
                    <span>{ticketDetails.priority}</span>
                </div>
                <div className="mjsdev-dtl-row">
                    <span>Status</span>
                    <span>{ticketDetails.status}</span>
                </div>
                <div className="mjsdev-dtl-row">
                    <span>Created On</span>
                    <span>
                        {new Date(ticketDetails.createdAt).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "long",
                            year: "numeric"
                        })}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default TicketDetails;
